var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_119_46)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4588 19.3281H13.5923C13.5582 19.0866 13.4886 18.8722 13.3835 18.6847C13.2784 18.4943 13.1435 18.3324 12.9787 18.1989C12.8139 18.0653 12.6236 17.9631 12.4077 17.892C12.1946 17.821 11.9631 17.7855 11.7131 17.7855C11.2614 17.7855 10.8679 17.8977 10.5327 18.1222C10.1974 18.3437 9.9375 18.6676 9.75284 19.0938C9.56818 19.517 9.47585 20.0312 9.47585 20.6364C9.47585 21.2585 9.56818 21.7812 9.75284 22.2045C9.94034 22.6278 10.2017 22.9474 10.5369 23.1634C10.8722 23.3793 11.2599 23.4872 11.7003 23.4872C11.9474 23.4872 12.1761 23.4545 12.3864 23.3892C12.5994 23.3239 12.7884 23.2287 12.9531 23.1037C13.1179 22.9759 13.2543 22.821 13.3622 22.6392C13.473 22.4574 13.5497 22.25 13.5923 22.017L15.4588 22.0256C15.4105 22.4261 15.2898 22.8125 15.0966 23.1847C14.9063 23.554 14.6491 23.8849 14.3253 24.1776C14.0043 24.4673 13.6207 24.6974 13.1747 24.8679C12.7315 25.0355 12.2301 25.1193 11.6705 25.1193C10.892 25.1193 10.196 24.9432 9.58239 24.5909C8.97159 24.2386 8.48864 23.7287 8.13352 23.0611C7.78125 22.3935 7.60511 21.5852 7.60511 20.6364C7.60511 19.6847 7.78409 18.875 8.14205 18.2074C8.5 17.5398 8.9858 17.0312 9.59943 16.6818C10.2131 16.3295 10.9034 16.1534 11.6705 16.1534C12.1761 16.1534 12.6449 16.2244 13.0767 16.3665C13.5114 16.5085 13.8963 16.7159 14.2315 16.9886C14.5668 17.2585 14.8395 17.5895 15.0497 17.9815C15.2628 18.3736 15.3991 18.8224 15.4588 19.3281ZM22.1726 16.2727H24.0178V21.9403C24.0178 22.5767 23.8658 23.1335 23.5618 23.6108C23.2607 24.0881 22.8388 24.4602 22.2962 24.7273C21.7536 24.9915 21.1214 25.1236 20.3999 25.1236C19.6754 25.1236 19.0419 24.9915 18.4993 24.7273C17.9567 24.4602 17.5348 24.0881 17.2337 23.6108C16.9325 23.1335 16.782 22.5767 16.782 21.9403V16.2727H18.6271V21.7827C18.6271 22.1151 18.6996 22.4105 18.8445 22.669C18.9922 22.9276 19.1996 23.1307 19.4666 23.2784C19.7337 23.4261 20.0447 23.5 20.3999 23.5C20.7578 23.5 21.0689 23.4261 21.3331 23.2784C21.6001 23.1307 21.8061 22.9276 21.951 22.669C22.0987 22.4105 22.1726 22.1151 22.1726 21.7827V16.2727ZM25.5359 25V16.2727H31.4165V17.794H27.381V19.8736H31.114V21.3949H27.381V23.4787H31.4336V25H25.5359Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_119_46",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_119_46"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_119_46"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCue);
export default __webpack_public_path__ + "static/media/cue.8c715a2b2f86cf084d853fd8db934b67.svg";
export { ForwardRef as ReactComponent };